import React, { useEffect, useState } from 'react'
import { apiGet } from '../../../utils/apiFetch'
import apiPath from '../../../utils/apiPath'
import OButton from 'components/reusable/OButton'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import dayjs from 'dayjs'
import Table from './Table'
import Pagination from '../../Pagination'
import { useTranslation } from 'react-i18next'
import ManageView from './ManageView'
import helpers from '../../../utils/helpers'
import CustomSelect from 'components/reusable/CustomSelect'
import { categoryOptions } from 'utils/constants'
import { useLocation } from 'react-router-dom'

const Listing = () => {
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const location = useLocation()
  const [pageSize] = useState(10)
  const [jobsView, setJobsView] = useState(false)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [employeeList, setEmployeeList] = useState([])
  const [currentItem, setCurrentItem] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [filterData, setFilterData] = useState({
    employeeType: '',
    searchkey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handleView = item => {
    setCurrentItem(item)
    setJobsView(!jobsView)
  }

  const allEmployee = async data => {
    try {
      const { employeeType, startDate, endDate, searchkey, isFilter } =
        filterData
      if (
        (data?.deletePage && employeeList?.length >= 1) ||
        (isFilter && data?.statusChange && employeeList?.length >= 1)
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }

      const payload = {
        page,
        pageSize,
        status: employeeType,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchkey?.trim(),
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }
      const path = apiPath.hrLeaveList
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setEmployeeList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response.totalDocs,
          null
        )
      })
    } catch (error) {
      console.log('error in get all employee list==>>>>', error.message)
    }
  }

  useEffect(() => {
    allEmployee()
  }, [page, filterData, sort])

  const handleReset = () => {
    setFilterData({
      employeeType: '',
      searchkey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
  }

  useEffect(() => {
    if (location.state)
      setFilterData({ ...filterData, employeeType: location.state })
  }, [location.state])

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }
  const statusPage = e => {
    setFilterData({
      ...filterData,
      employeeType: e.target.value,
      isFilter: true
    })
    setPage(1)
  }

  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true)
    } else if (searchTerm || !filterData?.isReset) {
      setFilterData({
        ...filterData,
        isReset: false,
        searchkey: helpers?.ternaryCondition(
          debouncedSearchTerm,
          debouncedSearchTerm,
          ''
        ),
        isFilter: helpers?.ternaryCondition(debouncedSearchTerm, true, false)
      })
      setPage(1)
    }
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='bg-white border border-[#E9EDF9] rounded-lg'>
          <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3 flex-wrap justify-between'>
            <div className='col-span-2 flex flex-wrap items-center mb-2 2xl:mb-0'>
              <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                <div className='relative flex items-center mb-3'>
                  <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                    {!searchTerm ? (
                      <svg
                        aria-hidden='true'
                        className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                        />
                      </svg>
                    ) : (
                      ''
                    )}
                  </div>
                  <input
                    type='search'
                    id='default-search'
                    className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                    placeholder='Employee name and ID'
                    value={searchTerm}
                    title=''
                    required
                    onChange={e => setSearchTerm(e.target.value)}
                  />
                </div>
                <ODateRangePicker
                  handleDateChange={handleDateChange}
                  isReset={filterData?.isReset}
                  setIsReset={setFilterData}
                />
                <CustomSelect
                  id='employeeType'
                  name='employeeType'
                  value={filterData.employeeType}
                  onChange={statusPage}
                  options={categoryOptions}
                  placeholder='O_ALL'
                  t={t}
                />
                <OButton
                  label='Reset'
                  type='button'
                  onClick={() => handleReset()}
                  extraClasses='ml-3 mb-3'
                  style={{ borderRadius: '0.5rem' }}
                />
              </div>
            </div>
            <div className='lg:pt-0 pt-2'>
              <label
                htmlFor='default-search'
                className='mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white'
              >
                {t('O_SEARCH')}
              </label>
            </div>
          </form>
          <Table
            employeeList={employeeList}
            page={page}
            allEmployee={allEmployee}
            currentItem={currentItem}
            setSort={setSort}
            sort={sort}
            setPage={setPage}
            handleView={handleView}
          />
          {jobsView && (
            <ManageView
              jobsView={jobsView}
              currentItem={currentItem}
              setJobsView={setJobsView}
              handleView={handleView}
              allRequest={employeeList}
            />
          )}
          {helpers.ternaryCondition(
            paginationObj?.totalItems,
            <Pagination
              handlePageClick={handlePageClick}
              options={paginationObj}
              page={page}
            />,
            null
          )}
        </div>
      </div>
    </>
  )
}

export default Listing
